<template>
    <div class="view-body">
      <div class="view-data">
        <div class="view-data__header">
          <h1>{{title}}</h1>
        </div>
        <div class="data-table__head">
            <div class="data-table-sort">
              <p>Pokaż</p>
              <select v-model="perPage" @change="getMarkets()">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
              <p>pozycji</p>
            </div>
          </div>
        <b-container fluid>
          <div class="table--wrapper">
          <!-- Main table element -->
            <b-table
              class="app-table markets-table"
              show-empty
              stacked="md"
              striped
              :busy="isBusy"
              :items="markets"
              :fields="fields"
              :paginated="false"
              :backend-sorting="true"
              @filtered="onFiltered"
              hover>

              <template slot="empty">
                <p class="empty-message">Brak rekordów</p>
              </template>

              <template slot="HEAD_city" slot-scope="row">
                <label :class="{'active' : sortField == 'cityMarketNumber'}" @click="sortDir('cityMarketNumber')">
                  {{row.label}}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'cityMarketNumber'"></div>
                </label>
              </template>

              <template slot="HEAD_category" slot-scope="row">
                <label :class="{'active' : sortField == 'category'}" @click="sortDir('category')">
                  {{row.label}}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'category'"></div>
                </label>
              </template>

              <template slot="HEAD_gallery" slot-scope="row">
                <label :class="{'active' : sortField == 'galleryName'}" @click="sortDir('galleryName')">
                  {{row.label}}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'galleryName'"></div>
                </label>
              </template>

              <template slot="HEAD_sapNumber" slot-scope="row">
                <label :class="{'active' : sortField == 'sapNumber'}" @click="sortDir('sapNumber')">
                  {{row.label}}
                  <div class="sort-control" v-bind:class="{ up: sortDirection == 'ASC', down: sortDirection == 'DESC' }" v-if="sortField == 'sapNumber'"></div>
                </label>
              </template>
              
              <template slot="city" slot-scope="row">
                {{ row.item.gallery_city ?  row.item.gallery_city : ''}} {{row.item.number ? row.item.number : ''}}
              </template>

              <template slot="category" slot-scope="row">
                {{row.item.category ? row.item.category.name : ''}}
              </template>

              <template slot="gallery" slot-scope="row">
                {{row.item.gallery ? row.item.gallery : ''}}
              </template>

              <template slot="sapNumber" slot-scope="row">
                {{row.item.sapNumber ? row.item.sapNumber : ''}}
              </template>

            </b-table>
          </div>
        </b-container>
        <b-row>
            <b-col class="my-1">
              <b-pagination
                v-if="!markets.length == 0"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0 float-right"
                @change="pageChange">
              </b-pagination>
            </b-col>
          </b-row>
      </div>
  </div>

</template>

<script>

import debounce from "lodash.debounce";

export default {

  name: 'Markets',
  data () {

    return {

      title: 'Lista marketów',

      isBusy: false,
      fields: [

          {
            key: 'sapNumber', 
            label: 'Nr SAP' 
          },
          {
            key: 'city', 
            label: 'Miasto i numer sklepu' 
          },
          {
            key: 'gallery', 
            label: 'Galeria handlowa' 
          },
          {
            key: 'category', 
            label: 'Kategoria' 
          },

        ],

      markets: [],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      offset: 0,
      sort: false,
      sortDirection: 'ASC',
      sortField: 'sapNumber',

    }

  },
  methods:{

    sortDir(field){

      if(field != this.sortField){

        this.sortField = field; 
        this.sortDirection = 'ASC',

        this.getMarkets();

        return;

      }
      
      this.sortDirection == 'DESC' ? this.sortDirection = 'ASC' : this.sortDirection = 'DESC';
      this.sortField = field;
      this.getMarkets();

    },

    getMarkets(){

      this.isBusy = true;

      const token = localStorage.getItem('auth_token');

      this.$http.get('market/markets', {
        params:{
          'limit' : this.perPage,
          'offset' : this.offset,
          'sort' : this.sortDirection,
          'sort_field' : this.sortField,
        },
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.markets = response.data.list;
          this.totalRows = response.data.total;
          this.isBusy = false;

        })
        .catch(error =>{
          
          if(error.response.status === 400 || error.response.status === 401 || error.response.status === 402) {
            
            this.$router.push('/');

          }else{

            console.error(error.response);
            this.loading = false;

          }

        })

    },

    searching: debounce(function(){

      this.getMarkets();

    }, 500),

    pageChange (page) {

      this.currentPage = page
      this.offset = ((this.currentPage - 1) * this.perPage)
      this.getMarkets()
      
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }

  },
  mounted(){

    this.getMarkets();

  }
};
</script>

<style lang="scss">

.loader{
  position: absolute;
}

</style>
